<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout v-show="ready" :show-background="true" container-class="max-w-sm px-4 py-10">
            <div v-if="ready">
                <div class="flex justify-center mb-8">
                    <img :src="config.service_logo" :alt="config.service_name" class="block w-auto h-12">
                </div>
                <h1 class="mb-32 text-xl font-bold leading-tight text-center text-highlight-100">
                    {{ _('confirmation_title') }}
                </h1>
                <div class="mb-18">
                    <h2 class="mb-8 text-lg font-bold leading-tight text-center text-highlight-100">
                        {{ _('confirmation_subtitle') }}
                    </h2>
                    <p class="leading-tight text-center text-highlight-100">
                        {{ _('confirmation_description') }}
                    </p>
                </div>
                <form
                    v-if="hasRedirectUrl"
                    method="POST"
                    :action="params.redirect_url"
                    class="hidden"
                    ref="form"
                >
                    <input type="hidden" name="token_type" :value="user.token_type">
                    <input type="hidden" name="expires_in" :value="user.expires_in">
                    <input type="hidden" name="access_token" :value="user.access_token">
                    <input type="hidden" name="refresh_token" :value="user.refresh_token">
                    <input type="hidden" name="device" :value="user.device">
                </form>
                <BaseButton type="button" class="mb-4 font-medium" @click.native="confirmationRedirect">
                    {{ _('confirmation_button') }}
                </BaseButton>
            </div>
            <Portal to="spinner">
                <div v-if="loading"
                        class="fixed inset-0 flex flex-col items-center justify-center p-8 bg-background-80">
                    <div class="mb-20">
                        <BaseSpinner/>
                    </div>
                </div>
            </Portal>
        </Layout>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseSpinner from '@/components/Base/BaseSpinner.vue'

export default {
    components: {
        Layout,
        BaseButton,
        BaseSpinner,
    },
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            client: 'settings/getClient',
            params: 'settings/get',
            user: 'user/authenticated',
        }),
        hasRedirectUrl() {
            return typeof this.params.redirect_url !== 'undefined'
                && this.params.redirect_url !== null
        },
    },
    created() {
        NProgress.start()
    },
    async mounted() {
        this.config = await import(`@/resources/${this.client}`)
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
    },
    data() {
        return {
            config: '',
            ready: false,
            loading: false,
        }
    },
    methods: {
        confirmationRedirect() {
            this.$store.dispatch('packs/reset')
            this.$store.dispatch('charge/reset')

            if (this.hasRedirectUrl) {
                this.loading = true
                return this.$refs.form.submit()
            }

            return this.dispatchCallback()
        },
    },
    dispatchCallback() {
        if (typeof AndroidCallbacks !== 'undefined') {
            // eslint-disable-next-line no-undef
            AndroidCallbacks.externalPurchaseCompleted(
                JSON.stringify(this.user),
            )
        }

        try {
            // eslint-disable-next-line no-undef
            webkit.messageHandlers.externalPurchaseCompleted.postMessage(
                JSON.stringify(this.user),
            )
        } catch (err) {
            // Not an iOS device
        }
    },
}
</script>
